<template>
<div>

    <div  class="modal" id="modalEpsonNotFiscalReceipt" tabindex="-1" data-backdrop="static" data-keyboard="false" >
        <div class="modal-dialog modal-dialog-centered"> 
        <div class="modal-content border border-success">
        <div  style="background-color : #9acd32;color:black" class="modal-header border border-success text-nowrap ">
        <h4 class="modal-title ">
          <i style="color:blue" class="fas fa-cash-register mr-3" ></i>     
          <strong>STAMPA DOCUMENTO GESTIONALE</strong>
        </h4>  
    </div>

    <div class="modal-body border border-success">

      <button @click="closeModal()" type="button" class="btn btn-outline-secondary float-left">
        <i class="fas fa-reply mr-2" ></i>
          ANNULLA
      </button>

      <button  @click="postXML()" :disabled="bt_spinner==true" type="button" class="btn btn-primary float-right">
          <i class="fas fa-print mr-2" ></i>   
            STAMPA 
          <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" ></span>
      </button>    


      <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
    
    </div>



  </div>
</div>
</div>
</div>


</template>

<script>

import { mapGetters }    from 'vuex';

import api               from '@/api'
import axios             from 'axios'
import alertBox          from '@/components/common/AlertBox.vue'
import fmt               from '@/components/mixins/fmt'
import getSaleData       from '@/components/rt/mixins/getSaleData'


  export default {
  mixins : [fmt,getSaleData],
  props  : ['saleId'],

     components: {alertBox},
    data () {
      return {
        
          msg      : {title : '',body:'',type :0},
                
          items       : [],
          payments    : [],
          bt_spinner  : false,
          deskId      : 1,
          fiscalPrinter : {}
                                   
      }
    },
    computed: 
  {
   ...mapGetters(['storeId','company']) ,   
      
     
  },
  mounted ()
    {
        $('#modalEpsonNotFiscalReceipt').modal('show')  
    }, 
    async created () 
      {

        let deskId = JSON.parse(localStorage.getItem("deskId"))
        
        if(deskId)
        {    
            this.deskId = Number(deskId)
        }

        console.log('EPSON NOT FISCAL RECEIPT DATA',this.saleId)
        const data     = await this.getSaleData(this.saleId)
        
        this.items     = data[0]
        this.payments  = data[1]
        this.getFiscalPrinter()
      },
    
    methods: 
    {
    
    closeModal()
    {
        $('#modalEpsonNotFiscalReceipt').modal('hide')
        this.$nextTick(()  => {              
          this.$emit('close')        
    })    
    },  
    async getFiscalPrinter()
    {
    

    const sp    = {'sp':'spStoreDeskFiscalPrinter'}
    const data  = {'storeId':this.storeId,'deskId':this.deskId}      
    const json  = Object.assign(data, sp)
      
      //this.bt_spinner = true
      await api.post(json).then(res => {
      if(res.status==200)
        {
          
         if(res.data.recordsets[0].length > 0) 
         {
            this.fiscalPrinter = res.data.recordsets[0][0]
            
         }
         console.log('FISCAL PRINTER ',this.fiscalPrinter)
        }
        else if(res.status==500)
        {
         
     
        
        } 
        else
        {
          
        
        } 
    }).catch(err => 
    {
      
     
       
    }).finally(() => {
      
    });

  

   },   
     getXML() 
     {
        
        //const crlf         =  '\r\n'  
        const maxLength    = 46  
      
        const spc          = ' '
        const description1 = 'ABBUONO'
        const description2 = 'TOTALE EURO '
        const description3 = 'euro'
        const notPaid      = this.payments.filter(item => item.typeId == 'CRED') 

                    let notPaidTotal = 0
                    notPaid.forEach(item => {
                        notPaidTotal += item.amount
                    })


        let xml = ''  
         
        const dataPayments   = this.payments.filter(item => item.typeId == 'ELEC' || item.typeId == 'PAGO' || item.typeId == 'SCAL') 
        let elecTotal = 0
            dataPayments.forEach(item=>{
              elecTotal += item.amount
            })
    

        let SubtotalAdjustment = this.items[0].total_discount
        this.payments.forEach(item=>{
              if(item.typeId == 'COUP')
              {
                SubtotalAdjustment += item.amount
              }
              if(item.typeId == 'CB')
              {
                SubtotalAdjustment += item.amount
              }
        })  
                    
        xml = '<printerNonFiscal><beginNonFiscal operator="1"/>'
       /* xml += '<Printer Num="1"/>'*/
        xml += '<printNormal operator="1" font="1" data="' + spc.repeat(maxLength - description3.length)  + description3 + '" />'            
        this.items.forEach(item => {      
            
            
            const total        = this.fmt1(item.price)
            const description1 = item.barcode + ' ' + item.category 
            const totalLength  = total.length
        
            xml += '<printNormal operator="1" font="1" data="' + description1 + spc.repeat(maxLength - description1.length -  totalLength)  +  total + '"/>'
            if(Number(item.discount > 0))
            {
                const total = '-' + this.fmt1(item.discount_value)
                const description = 'SCONTO ART.'
                const totalLength  = total.length
                xml += '<printNormal operator="1" font="1" data="' + description + spc.repeat(maxLength - description.length -  totalLength)  +  total +  '" />'
                        
          }

      })
      
      const total        = this.fmt1(this.items[0].total)      
      const totalLength  = total.length
      xml += '<printNormal operator="1" font="1"/>'
      xml += '<printNormal operator="1" font="1"/>'
      
      xml += '<printNormal operator="1" font="3" data="' + description2 + spc.repeat(maxLength - description2.length - totalLength) + total  + '"/>'

      if(SubtotalAdjustment > 0)
      {
        const total        = '-' + this.fmt1(SubtotalAdjustment)
        const totalLength  = total.length
        xml += '<printNormal operator="1" font="3" data="' + description1 + spc.repeat(maxLength - description1.length - totalLength) + total + '"/>'
      }
      xml += '<printNormal operator="1" font="1" />'     
      xml += '<printNormal operator="1" font="1" />'   
  
      this.payments.forEach(item=>{
          if(item.typeId == 'CASH')
          {
            
            const total        = this.fmt1(item.amount)            
            const totalLength  = total.length
            const description  = 'PAGAMENTO CONTANTE'
            xml += '<printNormal operator="1" font="1" data="' + description + spc.repeat(maxLength - description.length -  totalLength)  +  total +  '"/>'    
            
          }
          
        })   
        if(elecTotal > 0)
        {
            
            const total        = this.fmt1(elecTotal)            
            const totalLength  = total.length
            const description  = 'PAGAMENTO ELETTRONICO'
            xml += '<printNormal operator="1" font="1" data="' + description + spc.repeat(maxLength - description.length -  totalLength)  +  total +  '"/>'
          
        }            
        if(notPaidTotal > 0) 
        {
          
            const total        = this.fmt1(notPaidTotal)            
            const totalLength  = total.length
            const description  = 'NON RISCOSSO'
            xml += '<printNormal operator="1" font="1" data="' + description + spc.repeat(maxLength - description.length -  totalLength)  +  total +  '"/>'   
                    
        }
          
        xml += '<printNormal operator="1" font="1"' + '/>'      
        xml += '<printNormal operator="1" font="1"' + '/>'      
        
        
        xml += '<printBarCode  position="901" width="3" height="100" HRIPosition="1" HRIFont="A" codeType="69" code="' + "S" +  this.saleId + '"/>'
        xml += '<endNonFiscal operator="1" />' 
        xml += '</printerNonFiscal>'
        
          
          
          console.log('EPSON NOT FISCAL',xml)  
          return xml              
      },
      getSOAP(xml)
      {
            const soap = '<?xml version="1.0" encoding="utf-8"?>\n' +
            '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">\n' +
              '<s:Body>\n' + xml +
            '</s:Body>\n' +
            '</s:Envelope>\n'
            return soap
      },
      postXML()
      {   this.bt_spinner = true
          const soap = this.getSOAP(this.getXML())

          console.log('SOAP',soap)

          axios({
               
               url    : this.fiscalPrinter.url + '/cgi-bin/fpmate.cgi',
               method : 'post',
               data   : soap

             }).then(res => {
                this.bt_spinner = false
                console.log('Fiscal Printer Response',res)
               
                
             }).catch(err => {
                
                this.bt_spinner   = false   
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = err
                this.msg.type  = 1                          

               console.log('Error Fiscal Printer ',err)  
             })
       
      },    
         
   
     } 
      

    
  }
</script>
<style scoped>

/*
.modal-footer {  
  justify-content: space-between;  
}
  */


 
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.modal-content
{
  width:  500px;
}
</style>
